import { type ReactElement, useEffect, useRef } from 'react'
import { TextInput } from '~/components/Form/Input/TextInput'

type TextFilterEditorProps = {
  value: string
  placeholder?: string
  onChange: (value: string) => void
  onClose: () => void
  transform?: (value: string) => string
}

export const TextFilterEditor = ({
  value,
  placeholder = 'Rechercher...',
  onChange,
  onClose,
  transform
}: TextFilterEditorProps): ReactElement => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    wrapperRef.current?.querySelector('input')?.focus()
  }, [])

  const commit = (raw: string) => {
    const v = transform ? transform(raw.trim()) : raw.trim()
    onChange(v)
    onClose()
  }

  return (
    <div ref={wrapperRef}>
      <TextInput
        standalone
        wrapper={false}
        inputSize="small"
        placeholder={placeholder}
        defaultValue={value}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            commit(e.currentTarget.value)
          }
          if (e.key === 'Escape') onClose()
        }}
        onBlur={(e) => {
          commit(e.currentTarget.value)
        }}
      />
    </div>
  )
}
